import { Component, Input } from '@angular/core';
import { BaseModalComponent } from './base-modal.component';

@Component({
  selector: 'app-dialog-modal',
  template: require('./dialog-modal.component.html').default,
  styles: [
    require('!!raw-loader!sass-loader!./base-modal.component.scss').default,
    require('!!raw-loader!sass-loader!./dialog-modal.component.scss').default,
  ],
  animations: [BaseModalComponent.modalAnimations[0]],
  standalone: false,
})
export class DialogModalComponent extends BaseModalComponent {
  @Input() title = 'Meddelande';
  @Input() body = '';
  @Input() cancelText = 'Avbryt';
  @Input() confirmText = 'OK';
  @Input() showCancel = false;
  @Input() variant: 'info' | 'danger' = 'info';
}
